// extracted by mini-css-extract-plugin
export default {"maxCharactersDialog":"styles_maxCharactersDialog__Rqhoz","dialogTitle":"styles_dialogTitle__DC92z","dialogFooter":"styles_dialogFooter__bFO5P"};